<script>
  import Button from './Button.svelte';
  import { _ } from 'svelte-i18n';
</script>

<style>
  .call-to-action {
    background-color: rgba(35, 35, 35, 0.8);
    padding: 70 0px;
    text-align: center;
    color: #ffffff;
  }
  .heading {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 29px;
  }
  .features {
    display: flex;
    margin-bottom: 42px;
    justify-content: center;
    font-size: 16px;
    font-weight: normal;
    flex-wrap: wrap;
    padding: 0;
    opacity: 0.9;
  }
  .features li {
    list-style-type: disc;
    margin: 0 22px;
    flex-wrap: wrap;
  }
  @media (max-width: 600px) {
    .heading {
      font-size: 24px;
    }
  }
</style>

<div class="call-to-action">
  <div class="container">
    <h6 class="heading">{$_('callToAction.heading')}</h6>
    <ul class="features">
      <li>{$_('callToAction.features.1')}</li>
      <li>{$_('callToAction.features.2')}</li>
      <li>{$_('callToAction.features.3')}</li>
    </ul>
    <a href="/sign-up">
      <Button large>{$_('callToAction.action')}</Button>
    </a>
  </div>
</div>
